<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2x"><a id="page_v"></a>CONTENTS</h2>
<p class="toc"><a href="#/xhtml/acknowledgments#ack"><span class="small">ACKNOWLEDGMENTS</span></a></p>
<p class="toc"><a href="#/xhtml/introduction#int"><span class="small">INTRODUCTION</span></a></p>
<p class="tocp"><a href="#/xhtml/part1#part1"><strong><em>Part I. Setting the Context</em></strong></a></p>
<p class="toct"><a href="#/xhtml/chapter1#ch1">1. Judaism and the Love of Reason</a></p>
<p class="toca"><span class="small">MARTHA C. NUSSBAUM</span></p>
<p class="toct"><span href="#/xhtml/chapter2#ch2" title="Link target outside of Sample">2. Feminism, Socialism, and Christianity Revisited</span></p>
<p class="toca"><span class="small">MARY B. MAHOWALD</span></p>
<p class="toct"><span href="#/xhtml/chapter3#ch3" title="Link target outside of Sample">3. “Philosophizing on Saturday”: Faith and the Philosophical Life</span></p>
<p class="toca"><span class="small">WINIFRED WING HAN LAMB</span></p>
<p class="toct"><span href="#/xhtml/chapter4#ch4" title="Link target outside of Sample">4. Three Aspects of Identity</span></p>
<p class="toca"><span class="small">SR. MARY CHRISTINE MORKOVSKY</span></p>
<p class="toct"><span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample">5. Reflections on Identity</span></p>
<p class="toca"><span class="small">JEAN BETHKE ELSHTAIN</span></p>
<p class="tocp"><span href="#/xhtml/part2#part2" title="Link target outside of Sample"><strong><em>Part II. Tensions and Integrations</em></strong></span></p>
<p class="toct"><span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample">6. Yes</span></p>
<p class="toca"><span class="small">MARIANNE SAWICKI</span></p>
<p class="toct"><span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample">7. Into the Crucible: My Art of Living</span></p>
<p class="toca"><span class="small">JACQUELINE SCOTT</span></p>
<p class="toct"><span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample">8. Learning to Question</span></p>
<p class="toca"><span class="small">PATRICIA ALTENBERND JOHNSON</span></p>
<p class="toct"><span href="#/xhtml/chapter9#ch9" title="Link target outside of Sample">9. I Can’t Say No: Self-Sacrifice and an Ethics of Care</span></p>
<p class="toca"><span class="small">RUTH E. GROENHOUT</span></p>
<p class="toct"><span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample">10. Seduction: Does How You Get to “Yes” Still Matter?</span></p>
<p class="toca"><span class="small">CAROLINE J. SIMON</span></p>
<p class="toct"><a id="page_vi"></a><span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample">11. Living within Tradition</span></p>
<p class="toca"><span class="small">LAURA DUHAN KAPLAN</span></p>
<p class="toct"><span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample">12. Hagar on My Mind</span></p>
<p class="toca"><span class="small">AZIZAH Y. AL-HIBRI</span></p>
<p class="tocp"><span href="#/xhtml/part3#part3" title="Link target outside of Sample"><strong><em>Part III. Challenging Traditions</em></strong></span></p>
<p class="toct"><span href="#/xhtml/chapter13#ch13" title="Link target outside of Sample">13. A Skeptical Spirituality</span></p>
<p class="toca"><span class="small">NEL NODDINGS</span></p>
<p class="toct"><span href="#/xhtml/chapter14#ch14" title="Link target outside of Sample">14. Faith, Philosophy, Passions, and Feminism: Dangerous Attractions</span></p>
<p class="toca"><span class="small">IRMGARD SCHERER</span></p>
<p class="toct"><span href="#/xhtml/chapter15#ch15" title="Link target outside of Sample">15. On Being a Christian Philosopher and Not a Feminist</span></p>
<p class="toca"><span class="small">M. ELAINE BOTHA</span></p>
<p class="toct"><span href="#/xhtml/chapter16#ch16" title="Link target outside of Sample">16. Toward a Visionary Politics: Phenomenology, Psychoanalytic Feminism, and Transcendence</span></p>
<p class="toca"><span class="small">MARILYN NISSIM-SABAT</span></p>
<p class="toct"><span href="#/xhtml/chapter17#ch17" title="Link target outside of Sample">17. My Life Speaks</span></p>
<p class="toca"><span class="small">SARA EBENRECK</span></p>
<p class="toc1"><span href="#/xhtml/contributors#con" title="Link target outside of Sample"><span class="small">CONTRIBUTORS</span></span></p>
<p class="toct"><span href="#/xhtml/index#ind" title="Link target outside of Sample"><span class="small">INDEX</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?e4d0dc1c